export default "/images/vendor/flag-icon-css/flags/4x3/za.svg?cfcf99d22861d82c56582197f4d2ffc1";